import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

const CloseIcon = (props: IconProps) => {
  const { color = FORTA_WHITE } = props;
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4999 0.0834961C16.2528 0.0834961 20.9166 4.74719 20.9166 10.5002C20.9166 16.2531 16.2528 20.9168 10.4999 20.9168C4.74695 20.9168 0.083252 16.2531 0.083252 10.5002C0.083252 4.74719 4.74695 0.0834961 10.4999 0.0834961ZM10.4999 2.16683C5.89754 2.16683 2.16659 5.89779 2.16659 10.5002C2.16659 15.1026 5.89754 18.8335 10.4999 18.8335C15.1023 18.8335 18.8333 15.1026 18.8333 10.5002C18.8333 5.89779 15.1023 2.16683 10.4999 2.16683ZM8.29027 6.81728L10.4999 9.02693L12.7096 6.81726C13.1164 6.41045 13.776 6.41045 14.1827 6.81726C14.5895 7.22405 14.5895 7.8836 14.1827 8.29039L11.973 10.5001L14.1828 12.7098C14.5896 13.1166 14.5896 13.7762 14.1828 14.183C13.7761 14.5897 13.1165 14.5897 12.7097 14.183L10.4999 11.9732L8.29017 14.183C7.88338 14.5897 7.22383 14.5897 6.81703 14.183C6.41024 13.7762 6.41024 13.1166 6.81703 12.7098L9.02679 10.5001L6.81713 8.29041C6.41034 7.88362 6.41034 7.22408 6.81713 6.81728C7.22393 6.41049 7.88347 6.41049 8.29027 6.81728Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
